import { LayoutDashboardLeftMenu } from 'components/layouts/LayoutDashboard/components/LayoutDashboardLeftMenu/LayoutDashboardLeftMenu';
import { TopBarWidget } from 'modules/widgets/TopBarWidget/TopBarWidget';
import { lazyRefresh } from 'utils/lazyRefresh';

const AdminWidgetModule = lazyRefresh(() => import('modules/admin-widgets/AdminWidgetModule'));
const GlobalLoader = lazyRefresh(() => import('modules/widgets/GlobalLoader/GlobalLoader'));
const TwoFAWidget = lazyRefresh(() => import('modules/widgets/TwoFAWidget/TwoFAWidget'));
const ProjectDetailsTabWidget = lazyRefresh(
  () => import('modules/widgets/ProjectDetailsTabWidget/ProjectDetailsTabWidget')
);
const AdminTabWidget = lazyRefresh(() => import('modules/admin-widgets/AdminTabWidget/AdminTabWidget'));
const ProjectTitleTopbarWidget = lazyRefresh(
  () => import('modules/widgets/ProjectTitleTopbarWidget/ProjectTitleTopbarWidget')
);

export const widgetList = {
  topBar: TopBarWidget,
  leftMenu: LayoutDashboardLeftMenu,
  adminSectionTab: AdminWidgetModule,
  projectDetailsTab: ProjectDetailsTabWidget,
  adminTab: AdminTabWidget,
  globalLoader: GlobalLoader,
  react2faAuth: TwoFAWidget,
  projectTitleTopBar: ProjectTitleTopbarWidget,
};

export type Widget = keyof typeof widgetList;
